/**
 * @fileoverview Module for `src/campaigns/lib/accessors.js`.
 */

import { isDatePast } from '../../lib/dates';

/**
 * Returns whether a campaign should be considered completed.
 *
 * @param {Object} campaign - Campaign object.
 * @returns {boolean} True when campaign is complete or closed.
 */
function isCampaignCompleted(campaign) {
  return campaign.isCompleted || campaign.availableVoterCount < 1 || isDatePast(campaign.mailEndDate);
}

// eslint-disable-next-line import/prefer-default-export
export { isCampaignCompleted };
